/*
xs, extra-small: 0px
sm, small: 600px
md, medium: 900px
lg, large: 1200px
xl, extra-large: 1536px
*/

import React, { MutableRefObject, useContext, useEffect, useRef, useState } from 'react'
import { Container, Grid, IconButton, Paper, Typography } from '@mui/material'
import { ContextoGlobal, ContextoGlobalInterface } from '../../../GlobalStates/ContextoGlobal'
import Button from '@mui/material/Button'
import CloseIcon from '@mui/icons-material/Close'

import DataTable, { DataTableCabecalhoInterface } from '../../../DevComponents/DataTable'
import { useNavigate } from 'react-router-dom'
import BackEndAPI from '../../../Services/BackEndAPI'
import ExibirJSONDev from '../../../DevComponents/ExibirJSONDev'
import { EMDESENVOLVIMENTO } from '../../../ImportBackend/Config/emDesenvolvimento'
import { RespostaPadraoInterface } from '../../../ImportBackend/Interfaces/PadraoInterfaces'
import InputText from '../../../DevComponents/InputText'
import { SetorProducaoInterface } from '../../../ImportBackend/Interfaces/SetorProducaoInterfaces'
import { TipoMapaProducaoInterface } from '../../../ImportBackend/Interfaces/TipoMapaProducaoInterfaces'
import { rsMapasPendentesOuEmLeituraInterface } from '../../../ImportBackend/Interfaces/MapaProducaoInterfaces'
import ClsValidacao from '../../../Utils/ClsValidacao'
import ComboBox from '../../../DevComponents/ComboBox'
import ClsFormatacao, { DTFORMAT } from '../../../Utils/ClsFormatacao'
import { StatusMapaInterface, StatusMapaType, StatusMapaTypes } from '../../../ImportBackend/types/ConstantesDataTypes'

interface rsPesquisaInterface {
  dataProducao: string
  idSetorProducao: number
  idTipoMapaProducao: number
}

export default function PrepararAmostrasParaLeitura () {

  const navigate = useNavigate()

  const clsFormatacao: ClsFormatacao = new ClsFormatacao()

  const contexto = useContext( ContextoGlobal ) as ContextoGlobalInterface

  const clsApi = new BackEndAPI()

  const [pesquisa, setPesquisa] = useState<rsPesquisaInterface>( {
    // dataProducao: DateTime.now().toFormat( 'yyyy-MM-dd' ),
    dataProducao: '',
    idSetorProducao: 0,
    idTipoMapaProducao: 0
  } )

  const [rsMapasPendentesPreparacao, setRsMapasPendentesPreparacao] = useState<Array<rsMapasPendentesOuEmLeituraInterface>>( [] )
  const [erros, setErros] = useState( {} )

  // Tem a base completa de setores de produção e tipos de mapa de produção
  const [rsSetorProducao, setRsSetorProducao] = useState<Array<SetorProducaoInterface>>( [] )
  const [rsTipoMapaProducao, setRsTipoMapaProducao] = useState<Array<TipoMapaProducaoInterface>>( [] )

  // Apenas o que irá aparecer para o usuário na pesquisa
  const [rsSetorProducaoFiltro, setRsSetorProducaoFiltro] = useState<Array<SetorProducaoInterface>>( [] )
  const [rsTipoMapaProducaoFiltro, setRsTipoMapaProducaoFiltro] = useState<Array<TipoMapaProducaoInterface>>( [] )

  const btFechar = () => {
    navigate( '/' )
  }

  let cabecalho: MutableRefObject<Array<DataTableCabecalhoInterface>> = useRef<Array<DataTableCabecalhoInterface>>( [] )

  const setarCamposCabecalho = () => {

    let base: Array<DataTableCabecalhoInterface> = [
      {
        campo: 'dataProducao',
        cabecalho: 'Data Produção',
        alinhamento: 'left',
        format: ( rs ) => clsFormatacao.dataFromIsoUTC( rs, DTFORMAT.USUARIO )
      },
      {
        campo: 'descricaoSetorProducao',
        cabecalho: 'Setor',
        alinhamento: 'left'
      },
      {
        campo: 'descricaoTipoMapaProducao',
        cabecalho: 'Mapa',
        alinhamento: 'left'
      },
      {
        campo: 'bandeja',
        cabecalho: 'Bandeja',
        alinhamento: 'right'
      },
      {
        campo: 'qtdAmostras',
        cabecalho: 'Amostras',
        alinhamento: 'right'
      },
      {
        campo: 'primeiraAmostra',
        cabecalho: 'Amostra de',
        alinhamento: 'right'
      },
      {
        campo: 'ultimaAmostra',
        cabecalho: 'até',
        alinhamento: 'right'
      },
      {
        campo: 'status',
        cabecalho: 'Status',
        alinhamento: 'left',
        format: ( rs: string ) => StatusMapaTypes.find( ( item: StatusMapaInterface ) => item.idStatusMapa === rs )?.descricao
      },
    ]

    if ( pesquisa.dataProducao.length > 0 ) {
      base = base.filter( item => item.campo !== 'dataProducao' );
    }

    if ( pesquisa.idSetorProducao > 0 ) {
      base = base.filter( item => item.campo !== 'descricaoSetorProducao' );
    }

    if ( pesquisa.idTipoMapaProducao > 0 ) {
      base = base.filter( item => item.campo !== 'descricaoTipoMapaProducao' );
    }

    cabecalho.current = base

  }

  const pesquisarMapasPendentesPorDataProducao = () => {

    if ( validarDados() ) {

      setarCamposCabecalho()

      const query = `
        getMapasPendentesOuEmLeituraPorDataProducao(
          data: "${pesquisa.dataProducao}", 
          idSetorProducao: ${pesquisa.idSetorProducao}, 
          idTipoMapaProducao: ${pesquisa.idTipoMapaProducao})
      `

      clsApi.query<Array<rsMapasPendentesOuEmLeituraInterface>>( query, 'getMapasPendentesOuEmLeituraPorDataProducao', 'Pesquisando Mapas Pendentes...', contexto ).then( rs => {
        setRsMapasPendentesPreparacao( rs )
        filtrarSetorETipoMapaProducao( rs )
      } )

    }

  }

  const iniciarProducao = ( idMapaProducao: number, indice: number ) => {

    const mutation = `
      liberarMapaProducaoParaDigitacao(idMapaProducao: ${idMapaProducao}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'liberarMapaProducaoParaDigitacao', 'Atualizando Mapa de Produção...', contexto ).then( rs => {

      if ( rs.ok ) {

        const tmp: Array<rsMapasPendentesOuEmLeituraInterface> = [...rsMapasPendentesPreparacao]
        tmp[indice].status = StatusMapaType.LEITURA

        setRsMapasPendentesPreparacao( tmp );

      } else {

        contexto.setMensagemState( {
          tipo: 'error',
          mensagem: rs.mensagem,
          cb: null,
          exibir: true,
          exibirBotao: true,
          titulo: 'Erro ao Atualizar Mapa....'
        } )

      }

    } )

  }

  const cancelarProducao = ( idMapaProducao: number, indice: number ) => {

    const mutation = `
      cancelarLeituraMapaProducao(idMapaProducao: ${idMapaProducao}) {
        ok
        mensagem
      }
    `

    clsApi.mutation<RespostaPadraoInterface>( mutation, 'cancelarLeituraMapaProducao', 'Cancelando Mapa de Produção...', contexto ).then( rs => {

      if ( rs.ok ) {
        const tmp: Array<rsMapasPendentesOuEmLeituraInterface> = [...rsMapasPendentesPreparacao]
        tmp[indice].status = StatusMapaType.CADASTRADO

        setRsMapasPendentesPreparacao( tmp );
      } else {

        contexto.setMensagemState( {
          tipo: 'error',
          mensagem: rs.mensagem,
          cb: null,
          exibir: true,
          exibirBotao: true,
          titulo: 'Erro ao Atualizar Mapa....'
        } )

      }

    } )

  }

  const onChangeDataProducao = ( rs: string ) => {

    setPesquisa( { ...pesquisa, dataProducao: rs } )

  }

  const pesquisarSetorProducao = () => {
    const query = `
        getSetorProducao {
          idSetorProducao
          descricao
        }
      `

    clsApi.query<Array<SetorProducaoInterface>>( query, 'getSetorProducao', 'Pesquisando Setores de Produção...', contexto ).then( rs => {
      setRsSetorProducao( rs )
      setRsSetorProducaoFiltro( rs )

    } )
  }

  const pesquisarTipoMapaProducao = () => {
    const query = `
        getTiposMapaProducao {
          idTipoMapaProducao
          descricao
        }
      `

    clsApi.query<Array<TipoMapaProducaoInterface>>( query, 'getTiposMapaProducao', 'Pesquisando Tipos de Mapa de Produção...', contexto ).then( rs => {
      setRsTipoMapaProducao( rs )
      setRsTipoMapaProducaoFiltro( rs )
    } )
  }

  const filtrarSetorETipoMapaProducao = ( rs: Array<rsMapasPendentesOuEmLeituraInterface> ) => {

    if ( rs.length > 0 ) {

      let rsFiltroSetorProducao: Array<SetorProducaoInterface> = []
      let rsFiltroTipoMapaProducao: Array<TipoMapaProducaoInterface> = []

      rs.forEach( ( rs ) => {

        let indice: number = rsFiltroSetorProducao.findIndex( ( item ) => item.idSetorProducao === rs.idSetorProducao )

        if ( indice < 0 ) {
          rsFiltroSetorProducao.push( rsSetorProducao.find( ( item ) => item.idSetorProducao === rs.idSetorProducao ) as SetorProducaoInterface )
        }

        indice = rsFiltroTipoMapaProducao.findIndex( ( item ) => item.idTipoMapaProducao === rs.idTipoMapaProducao )

        if ( indice < 0 ) {
          rsFiltroTipoMapaProducao.push( rsTipoMapaProducao.find( ( item ) => item.idTipoMapaProducao === rs.idTipoMapaProducao ) as TipoMapaProducaoInterface )
        }

      } )

      setRsSetorProducaoFiltro( rsFiltroSetorProducao )
      setRsTipoMapaProducaoFiltro( rsFiltroTipoMapaProducao )

    } else {

      setRsSetorProducaoFiltro( rsSetorProducao )

      setRsTipoMapaProducaoFiltro( rsTipoMapaProducao )

    }

  }

  useEffect( () => {

    pesquisarSetorProducao()
    pesquisarTipoMapaProducao()
    setarCamposCabecalho()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] )

  const validarDados = (): boolean => {
    let retorno: boolean = true
    let erros: { [key: string]: string } = {}

    let clsValidacao = new ClsValidacao()

    retorno = clsValidacao.eData( 'dataProducao', pesquisa, erros, retorno, true )

    setErros( erros )

    return retorno
  }

  return (
    <>

      <Container maxWidth="lg" sx={{ mt: 5 }}>

        <Paper variant="outlined" sx={{ padding: 2 }}>
          <Grid container sx={{ display: 'flex', alignItems: 'stretch' }}>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
              <Typography component="h5" variant="h5" align="left">
                Preparar Amostras para Leitura
                <Typography variant="body2" gutterBottom>
                  Baixa e Liberação de Mapas de Produção para Leitura no Laboratório
                </Typography>
              </Typography>

              <IconButton onClick={() => btFechar()}>
                <CloseIcon />
              </IconButton>
            </Grid>

            <Grid item xs={12} md={2} >

              <InputText
                dados={pesquisa}
                field='dataProducao'
                label='Data da Produção'
                // setState={setPesquisa}
                tipo='date'
                erros={erros}
                onChange={( v ) => onChangeDataProducao( v )}
              />

            </Grid>

            <Grid item xs={12} md={4} sx={{ pl: { md: 1 } }}>

              <ComboBox<SetorProducaoInterface>
                setState={setPesquisa}
                field='idSetorProducao'
                label='Setor Produção'
                dados={pesquisa}
                campoDescricao='descricao'
                campoID='idSetorProducao'
                opcoes={rsSetorProducaoFiltro}
              />

            </Grid>

            <Grid item xs={12} md={4} sx={{ pl: { md: 1 } }}>

              <ComboBox<TipoMapaProducaoInterface>
                setState={setPesquisa}
                field='idTipoMapaProducao'
                label='Mapa de Produção'
                dados={pesquisa}
                campoDescricao='descricao'
                campoID='idTipoMapaProducao'
                opcoes={rsTipoMapaProducaoFiltro}
              />

            </Grid>

            <Grid textAlign='right' item xs={12} md={2} sx={{ mt: 4.5, textAlign: 'left', pl: { md: 1 } }}>
              <Button variant='contained' onClick={() => pesquisarMapasPendentesPorDataProducao()} >Pesquisar</Button>
            </Grid>

            <Grid item xs={12} sx={{ mt: 4.5 }}>
              <DataTable
                cabecalho={cabecalho.current}
                dados={rsMapasPendentesPreparacao}
                acoes={[
                  {
                    icone: 'play_circle', // MUI icon for indicating start
                    toolTip: 'Iniciar Preparação Amostra',
                    onDisabled: ( rs: rsMapasPendentesOuEmLeituraInterface ) => rs.status !== StatusMapaType.CADASTRADO,
                    onAcionador: ( rs: rsMapasPendentesOuEmLeituraInterface, indice: number ) => iniciarProducao( rs.idMapaProducao, indice )
                  },
                  {
                    icone: 'cancel_circle', // MUI icon for cancel start
                    toolTip: 'Cancelar Preparação Amostra',
                    onDisabled: ( rs: rsMapasPendentesOuEmLeituraInterface ) => rs.status !== StatusMapaType.LEITURA,
                    onAcionador: ( rs: rsMapasPendentesOuEmLeituraInterface, indice: number ) => cancelarProducao( rs.idMapaProducao, indice )
                  }
                ]}
              />
            </Grid>

            <ExibirJSONDev exibir={EMDESENVOLVIMENTO} oque={['rsMapasPendentesPreparacao', rsMapasPendentesPreparacao]} />

          </Grid>

        </Paper>

      </Container >
    </>
  )
}